
import * as ActionTypes from "./ActionTypes";


export const setW9formData = (data) => {
    return({
    type: ActionTypes.SET_W9_FORM_DATA,
    data
  })};
